import { Link } from "react-router-dom";
import { ArrowRight, KeyRound } from "lucide-react";
import { euro } from "../lib/api";
import { qjStatus, QJ_FALLBACK_IMG, QJ_BTW, qjPrijs } from "../lib/qj";

export default function QJModelCard({ m, onTestrit, fromCat }) {
  const st = qjStatus(m.beschikbaarheid);
  const sold = m.beschikbaarheid === "uitverkocht";
  return (
    <div data-testid={`qj-card-${m.id}`} className="group flex flex-col w-full bg-[#141518] border border-[#2A2B31] hover:border-[#5A5C63] transition-colors duration-300 overflow-hidden">
      <Link to={`/qj-motor/${m.id}`} state={{ cat: fromCat }} className="relative block aspect-[4/3] overflow-hidden bg-[#0A0A0B]">
        <img src={m.images?.[0] || QJ_FALLBACK_IMG} alt={m.naam} loading="lazy"
          className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 ${sold ? "opacity-50" : ""}`} />
        <span data-testid={`qj-card-status-${m.id}`} className={`absolute top-0 left-0 font-display uppercase text-xs font-700 tracking-wider px-3 py-1.5 ${st.cls}`}>{st.label}</span>
      </Link>
      <div className="p-5 md:p-6 flex flex-col flex-1">
        {m.categorie && <p className="font-mono-tt text-[10px] uppercase tracking-[0.25em] text-[#E10600] mb-1">{m.categorie}</p>}
        <Link to={`/qj-motor/${m.id}`} state={{ cat: fromCat }} data-testid={`qj-card-name-${m.id}`} className="font-display uppercase font-800 text-2xl text-white leading-tight hover:text-[#E10600] transition-colors">{m.naam}</Link>
        <p className="mt-3 mb-5">
          <span data-testid={`qj-card-price-${m.id}`} className="font-display font-800 text-2xl text-white">{qjPrijs(m.prijs)}</span>
          {m.prijs != null && <span className="text-xs text-[#9A9CA3] ml-2">{QJ_BTW}</span>}
        </p>
        <div className="mt-auto grid gap-2">
          <button onClick={() => onTestrit(m)} data-testid={`qj-card-testrit-${m.id}`}
            className="inline-flex items-center justify-center gap-1.5 bg-[#E10600] hover:bg-[#B80500] text-white font-display uppercase font-700 text-xs tracking-wider px-3 py-3.5 transition-colors">
            <KeyRound size={14} /> Vraag een testrit aan
          </button>
          <Link to={`/qj-motor/${m.id}`} state={{ cat: fromCat }} data-testid={`qj-card-btn-${m.id}`}
            className="inline-flex items-center justify-center gap-1.5 border border-[#2A2B31] hover:border-white text-white font-display uppercase font-700 text-xs tracking-wider px-3 py-3.5 transition-colors">
            Bekijk model <ArrowRight size={13} />
          </Link>
        </div>
      </div>
    </div>
  );
}
